import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en_bell_overrides from './locales/cspSpecific/bell/en_bell.json';
import en_CA_bell_overrides from './locales/cspSpecific/bell/en_CA_bell.json';
import fr_CA_bell_overrides from './locales/cspSpecific/bell/fr_CA_bell.json';
import de from './locales/de.json';
import en from './locales/en.json';
import en_CA from './locales/en_CA.json';
import en_GB from './locales/en_GB.json';
import en_SG from './locales/en_SG.json';
import es from './locales/es.json';
import et from './locales/et.json';
import fr from './locales/fr.json';
import fr_CA from './locales/fr_CA.json';
import ja from './locales/ja.json';
import ms from './locales/ms.json';
import nl from './locales/nl.json';
import pt from './locales/pt.json';
import uk from './locales/uk.json';

import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/en-ca';
import 'dayjs/locale/en-sg';
import 'dayjs/locale/es';
import 'dayjs/locale/et';
import 'dayjs/locale/fr';
import 'dayjs/locale/fr-ca';
import 'dayjs/locale/ja';
import 'dayjs/locale/ms';
import 'dayjs/locale/nl';
import 'dayjs/locale/pt';
import 'dayjs/locale/uk';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: process.env.REACT_APP_APP_ENV !== 'production',
    detection: {
      order: ['querystring', 'navigator', 'htmlTag'],
    },
    resources: {
      en: {
        translation: en,
        bell: en_bell_overrides,
      },
      en_CA: {
        translation: en_CA,
        bell: en_CA_bell_overrides,
      },
      en_GB: { translation: en_GB, bell: en_GB },
      en_SG: { translation: en_SG, bell: en_SG },
      'en-SG': { translation: en_SG, bell: en_SG },
      fr: { translation: fr, bell: fr_CA_bell_overrides },
      'fr-CA': { translation: fr_CA, bell: fr_CA_bell_overrides },
      ja: { translation: ja, bell: ja },
      pt: { translation: pt, bell: pt },
      es: { translation: es, bell: es },
      de: { translation: de, bell: de },
      et: { translation: et, bell: et },
      nl: { translation: nl, bell: nl },
      uk: { translation: uk, bell: uk },
      ms: { translation: ms, bell: ms },
    },
    interpolation: {
      escapeValue: false,
    },
    fallbackNS: 'translation',
    returnNull: false,
  });

export default i18n;
